import { useContext } from "react"
import { SiteLocation } from "../SiteLocation"
export function usePathname() {
  return useContext(SiteLocation)
}
